// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/implement.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { HitchType, hitchTypeFromJSON, hitchTypeToJSON } from "../atk/enums";

export const protobufPackage = "carbon.rtc";

export interface ImplementDefinition {
  hitchType: HitchType;
  widthM: number;
  hitchToStartM: number;
  hitchToEndM: number;
  toolSpeedKmh: number;
  transitionSpeedKmh: number;
  runUpDistanceM: number;
  straightenDistanceM: number;
}

export interface ToolSpeed {
  toolSpeedMS: number;
}

export interface TransitionSpeed {
  transitionSpeedMS: number;
}

function createBaseImplementDefinition(): ImplementDefinition {
  return {
    hitchType: 0,
    widthM: 0,
    hitchToStartM: 0,
    hitchToEndM: 0,
    toolSpeedKmh: 0,
    transitionSpeedKmh: 0,
    runUpDistanceM: 0,
    straightenDistanceM: 0,
  };
}

export const ImplementDefinition: MessageFns<ImplementDefinition> = {
  encode(message: ImplementDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hitchType !== 0) {
      writer.uint32(8).int32(message.hitchType);
    }
    if (message.widthM !== 0) {
      writer.uint32(21).float(message.widthM);
    }
    if (message.hitchToStartM !== 0) {
      writer.uint32(29).float(message.hitchToStartM);
    }
    if (message.hitchToEndM !== 0) {
      writer.uint32(37).float(message.hitchToEndM);
    }
    if (message.toolSpeedKmh !== 0) {
      writer.uint32(45).float(message.toolSpeedKmh);
    }
    if (message.transitionSpeedKmh !== 0) {
      writer.uint32(53).float(message.transitionSpeedKmh);
    }
    if (message.runUpDistanceM !== 0) {
      writer.uint32(61).float(message.runUpDistanceM);
    }
    if (message.straightenDistanceM !== 0) {
      writer.uint32(69).float(message.straightenDistanceM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hitchType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.widthM = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.hitchToStartM = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.hitchToEndM = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.toolSpeedKmh = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.transitionSpeedKmh = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.runUpDistanceM = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.straightenDistanceM = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementDefinition {
    return {
      hitchType: isSet(object.hitchType)
        ? hitchTypeFromJSON(object.hitchType)
        : isSet(object.hitch_type)
        ? hitchTypeFromJSON(object.hitch_type)
        : 0,
      widthM: isSet(object.widthM)
        ? globalThis.Number(object.widthM)
        : isSet(object.width_m)
        ? globalThis.Number(object.width_m)
        : 0,
      hitchToStartM: isSet(object.hitchToStartM)
        ? globalThis.Number(object.hitchToStartM)
        : isSet(object.hitch_to_start_m)
        ? globalThis.Number(object.hitch_to_start_m)
        : 0,
      hitchToEndM: isSet(object.hitchToEndM)
        ? globalThis.Number(object.hitchToEndM)
        : isSet(object.hitch_to_end_m)
        ? globalThis.Number(object.hitch_to_end_m)
        : 0,
      toolSpeedKmh: isSet(object.toolSpeedKmh)
        ? globalThis.Number(object.toolSpeedKmh)
        : isSet(object.tool_speed_kmh)
        ? globalThis.Number(object.tool_speed_kmh)
        : 0,
      transitionSpeedKmh: isSet(object.transitionSpeedKmh)
        ? globalThis.Number(object.transitionSpeedKmh)
        : isSet(object.transition_speed_kmh)
        ? globalThis.Number(object.transition_speed_kmh)
        : 0,
      runUpDistanceM: isSet(object.runUpDistanceM)
        ? globalThis.Number(object.runUpDistanceM)
        : isSet(object.run_up_distance_m)
        ? globalThis.Number(object.run_up_distance_m)
        : 0,
      straightenDistanceM: isSet(object.straightenDistanceM)
        ? globalThis.Number(object.straightenDistanceM)
        : isSet(object.straighten_distance_m)
        ? globalThis.Number(object.straighten_distance_m)
        : 0,
    };
  },

  toJSON(message: ImplementDefinition): unknown {
    const obj: any = {};
    if (message.hitchType !== 0) {
      obj.hitchType = hitchTypeToJSON(message.hitchType);
    }
    if (message.widthM !== 0) {
      obj.widthM = message.widthM;
    }
    if (message.hitchToStartM !== 0) {
      obj.hitchToStartM = message.hitchToStartM;
    }
    if (message.hitchToEndM !== 0) {
      obj.hitchToEndM = message.hitchToEndM;
    }
    if (message.toolSpeedKmh !== 0) {
      obj.toolSpeedKmh = message.toolSpeedKmh;
    }
    if (message.transitionSpeedKmh !== 0) {
      obj.transitionSpeedKmh = message.transitionSpeedKmh;
    }
    if (message.runUpDistanceM !== 0) {
      obj.runUpDistanceM = message.runUpDistanceM;
    }
    if (message.straightenDistanceM !== 0) {
      obj.straightenDistanceM = message.straightenDistanceM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementDefinition>, I>>(base?: I): ImplementDefinition {
    return ImplementDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementDefinition>, I>>(object: I): ImplementDefinition {
    const message = createBaseImplementDefinition();
    message.hitchType = object.hitchType ?? 0;
    message.widthM = object.widthM ?? 0;
    message.hitchToStartM = object.hitchToStartM ?? 0;
    message.hitchToEndM = object.hitchToEndM ?? 0;
    message.toolSpeedKmh = object.toolSpeedKmh ?? 0;
    message.transitionSpeedKmh = object.transitionSpeedKmh ?? 0;
    message.runUpDistanceM = object.runUpDistanceM ?? 0;
    message.straightenDistanceM = object.straightenDistanceM ?? 0;
    return message;
  },
};

function createBaseToolSpeed(): ToolSpeed {
  return { toolSpeedMS: 0 };
}

export const ToolSpeed: MessageFns<ToolSpeed> = {
  encode(message: ToolSpeed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.toolSpeedMS !== 0) {
      writer.uint32(17).double(message.toolSpeedMS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolSpeed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolSpeed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.toolSpeedMS = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolSpeed {
    return {
      toolSpeedMS: isSet(object.toolSpeedMS)
        ? globalThis.Number(object.toolSpeedMS)
        : isSet(object.tool_speed_m_s)
        ? globalThis.Number(object.tool_speed_m_s)
        : 0,
    };
  },

  toJSON(message: ToolSpeed): unknown {
    const obj: any = {};
    if (message.toolSpeedMS !== 0) {
      obj.toolSpeedMS = message.toolSpeedMS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolSpeed>, I>>(base?: I): ToolSpeed {
    return ToolSpeed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolSpeed>, I>>(object: I): ToolSpeed {
    const message = createBaseToolSpeed();
    message.toolSpeedMS = object.toolSpeedMS ?? 0;
    return message;
  },
};

function createBaseTransitionSpeed(): TransitionSpeed {
  return { transitionSpeedMS: 0 };
}

export const TransitionSpeed: MessageFns<TransitionSpeed> = {
  encode(message: TransitionSpeed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.transitionSpeedMS !== 0) {
      writer.uint32(17).double(message.transitionSpeedMS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionSpeed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionSpeed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.transitionSpeedMS = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionSpeed {
    return {
      transitionSpeedMS: isSet(object.transitionSpeedMS)
        ? globalThis.Number(object.transitionSpeedMS)
        : isSet(object.transition_speed_m_s)
        ? globalThis.Number(object.transition_speed_m_s)
        : 0,
    };
  },

  toJSON(message: TransitionSpeed): unknown {
    const obj: any = {};
    if (message.transitionSpeedMS !== 0) {
      obj.transitionSpeedMS = message.transitionSpeedMS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TransitionSpeed>, I>>(base?: I): TransitionSpeed {
    return TransitionSpeed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TransitionSpeed>, I>>(object: I): TransitionSpeed {
    const message = createBaseTransitionSpeed();
    message.transitionSpeedMS = object.transitionSpeedMS ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
